import DataViewerCardModel from "../../dataViewers/dashboard/DataViewerCardModel.js";
import SortModels from "../../filters/sort/SortModels.js";
import HistorySortActionRenderer from "./HistorySortActionRenderer.js";
export default {
  id: 'sort.history.GroupScreen',
  layout: {
    sort: 'a'
  },
  handles: context => {
    const {
      clientProps
    } = context;
    const {
      delegate,
      objectType,
      dataViewerCardModel
    } = clientProps;
    const sortModel = SortModels.getSortModelFor(delegate.type, objectType);
    const needsOrder = dataViewerCardModel && DataViewerCardModel.getNeedsOrder(dataViewerCardModel);
    return sortModel != null && !needsOrder;
  },
  matches: {
    use: 'filterBar',
    client: 'HistoryView'
  },
  customComponent: HistorySortActionRenderer
};